import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { AuthUtils } from "../auth/AuthUtils";
import { HttpMethod } from "src/enum/enums";
import {StringUtils} from "src/constant/constants";

interface requestProps {
  url: string;
  method: HttpMethod;
  body?: any;
  queryParams?: Record<string, string>;
  headers?: Record<string, string>;
  withCredentials?: boolean;
}

/**
 * This function is used to make backend api calls.
 */
export const backendServiceClient = async ({
  url, method, body, queryParams = {}, headers = {}, withCredentials = false}: requestProps): Promise<AxiosResponse> => {
  //reloading the window if the window.name is empty as this value is required header.
  if (window.name === StringUtils.EMPTY) {
    window.location.reload();
  }
  
  let config: AxiosRequestConfig = {
    url: url,
    method: method,
    params: queryParams,
    headers: {
      ...headers,
      "content-type": "application/json",
      "x-employee-alias": window.name,
      Authorization: await AuthUtils.getCognitoIdToken(),
    },
    data: body,
    withCredentials: withCredentials,
  }

  return axios.request(config);
}
